.header {
  border-bottom: 1px solid light-dark(var(--mantine-color-gray-3), var(--mantine-color-dark-4));
  background-color: var(--mantine-color-white);
}

.inner {
  height: 56px;
}

.logo {
  flex-shrink: 0;
  text-decoration: none;
}

.desktopNav {
  flex-shrink: 0;
}

.link {
  flex-shrink: 0;
  white-space: nowrap;
  padding: 8px 12px;
  border-radius: var(--mantine-radius-sm);
  text-decoration: none;
  color: light-dark(var(--mantine-color-gray-7), var(--mantine-color-dark-0));
  font-weight: 500;
  font-size: var(--mantine-font-size-sm);

  @mixin hover {
    background-color: light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-6));
    color: light-dark(var(--mantine-color-gray-9), var(--mantine-color-dark-0));
  }
}

.linkActive {
  color: var(--mantine-color-pachubColourScheme-7);
  background-color: light-dark(
    var(--mantine-color-pachubColourScheme-0),
    var(--mantine-color-dark-6)
  );
}

.linkCta {
  color: var(--mantine-color-pachubColourScheme-7);
  background-color: light-dark(
    var(--mantine-color-pachubColourScheme-0),
    var(--mantine-color-dark-6)
  );
  box-shadow: inset 0 0 0 1px light-dark(
    var(--mantine-color-pachubColourScheme-3),
    var(--mantine-color-pachubColourScheme-7)
  );
}

.linkCta:hover {
  background-color: light-dark(
    var(--mantine-color-pachubColourScheme-1),
    var(--mantine-color-dark-5)
  );
  color: light-dark(
    var(--mantine-color-pachubColourScheme-8),
    var(--mantine-color-pachubColourScheme-2)
  );
}

.linkCta.linkActive {
  background-color: light-dark(
    var(--mantine-color-pachubColourScheme-1),
    var(--mantine-color-dark-5)
  );
  box-shadow: inset 0 0 0 1px var(--mantine-color-pachubColourScheme-5);
}
